import { HttpResponse, httpCreators } from 'rbh-merchant-core';
import { put, takeLatest, call } from 'redux-saga/effects';
import { userCreators } from './user-action';
import { USER_STATE_KEY } from './user-reducer';
import { generalCreators } from '../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { USER_ACTION_TYPE } from './user-type';
import { BRANCH_REQUEST_ID_LIST } from '../../BranchManagement/redux/branch-constant';
import { BranchService } from '../../BranchManagement/redux/branch-service';
import { UserService } from './user-service';
import { USER_REQUEST_ID_LIST } from './user-constant';
import { generalSagas } from '../../../../redux/general/general-saga';

function* getUserHandler(response: HttpResponse) {
  if (response.success) {
    const users = response.data.map((u: any) => {
      u.key = u.merchantUserId;
      return u;
    });
    yield put(userCreators.setUserState(USER_STATE_KEY.LIST, users as []));
  } else {
    yield put(userCreators.setUserState(USER_STATE_KEY.LIST, undefined));
  }
}

function* editUserHandler(response: HttpResponse, callbackParams: any) {
  if (response.success) {
    callbackParams();
  } else {
    const modalData: any = {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    };

    if (response.statusCode === 1799) {
      modalData.modalTitle = 'main.user.form.add.duplicated.email.modal.title';
      modalData.modalContent = 'main.user.form.add.duplicated.email.modal.content';
    }

    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, modalData));
  }
}

function* addUserHandler(response: HttpResponse, callbackParams: any) {
  if (response.success) {
    callbackParams();
  } else {
    const modalData: any = {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    };

    if (response.statusCode === 1799) {
      modalData.modalTitle = 'main.user.form.add.duplicated.email.modal.title';
      modalData.modalContent = 'main.user.form.add.duplicated.email.modal.content';
    }

    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, modalData));
  }
}

function* deleteUserHandler(response: HttpResponse, callbackParams: any) {
  if (response.success) {
    callbackParams();
  } else {
    const modalData: any = {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    };

    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, modalData));
  }
}

function* getFilterBranchHandler(response: HttpResponse, callbackParams: any) {
  let shopDefault;
  if (response.success) {
    const shopData = response.data.shops;
    const filterShop = (shop: any) => {
      if (callbackParams) {
        if (shop.merchantUser) {
          if (shop.merchantUser.merchantUserId === callbackParams.merchantUserId) {
            shopDefault = callbackParams.shop.shopId;
            return true;
          } else {
            return false;
          }
        }
      } else {
        if (shop.merchantUser) {
          return false;
        }
      }

      return true;
    };

    const filteredShop = shopData.filter(filterShop);
    yield put(userCreators.setUserState(USER_STATE_KEY.BRANCH_FILTER_DEFAULT_ID, shopDefault));
    yield put(userCreators.setUserState(USER_STATE_KEY.BRANCH_FILTER_LIST, filteredShop as []));
  } else {
    yield put(userCreators.setUserState(USER_STATE_KEY.BRANCH_FILTER_DEFAULT_ID, undefined));
    yield put(userCreators.setUserState(USER_STATE_KEY.BRANCH_FILTER_LIST, undefined));
  }
}

function* callUser() {
  yield put(httpCreators.request({
    id: USER_REQUEST_ID_LIST.GET_USER,
    sagaHandler: getUserHandler as any,
    service: UserService.getUser
  }));
  yield call(generalSagas.callTnc);
}

function* callFilterBranch(data: any) {
  yield put(httpCreators.request({
    id: BRANCH_REQUEST_ID_LIST.GET_BRANCH,
    sagaHandler: getFilterBranchHandler as any,
    service: BranchService.getBranch,
    callbackParams: data.param
  }));
}

export const userSagas = {
  getFilterBranchHandler,
  callFilterBranch,
  callUser,
  getUserHandler,
  addUserHandler,
  editUserHandler,
  deleteUserHandler,
  watchers: [
    takeLatest(USER_ACTION_TYPE.CALL_USER, callUser),
    takeLatest(USER_ACTION_TYPE.CALL_FILTER_BRANCH, callFilterBranch),
  ]
};
